import { render, staticRenderFns } from "./StaffProcess.vue?vue&type=template&id=246f0935"
import script from "./StaffProcess.vue?vue&type=script&lang=js"
export * from "./StaffProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports